import { isValid } from "date-fns";
import {
  CurrencyInput,
  DatePicker,
  Grid,
  TextField,
} from "../../../../components";
import { formatDate, unformatPrice } from "../../../../utils";

const FormAnvisaDialog = ({
  produto,
  setProduto,
  produtoEntity,
  inputErros,
}) => {
  const handleDateChange = (prop, date) => {
    const value = isValid(date) ? formatDate.toSend(date) : null;
    produtoEntity.setHandleChangeInput(prop, value);
    setProduto({ ...produtoEntity });
  };

  const handleFloatChange = (e) => {
    const unformatValue = unformatPrice(e.target.value);
    produtoEntity.setHandleChangeInput(e.target.name, unformatValue);
    setProduto({ ...produtoEntity });
  };

  const handleInputChange = (e) => {
    produtoEntity.setHandleChangeInput(e.target.name, e.target.value);
    setProduto({ ...produtoEntity });
  };

  const nextFocusInput = (event) => {
    let inputCount = 2;
    if (event.keyCode === 13 && event.target.nodeName === "INPUT") {
      const { form } = event.target;
      if (!form) return;
      const index = Array.from(form.elements).indexOf(event.target);
      let element = form.elements[index + inputCount];
      if (element?.disabled) {
        element = form.elements[index + inputCount + 2];
      }
      if (element) {
        element.focus();
      }
      event.preventDefault();
    }
  };

  return (
    <>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={6}>
          <DatePicker
            required
            id={"dataValidade"}
            label={"Data de Validade"}
            name={"dataValidade"}
            format="dd/MM/yyyy"
            onChange={(date) => handleDateChange("dataValidade", date)}
            error={inputErros.get("dataValidade")}
            value={produto?.dataValidade}
          />
        </Grid>
        <Grid item xs={6}>
          <DatePicker
            required
            id={"dataFabricacao"}
            label={"Data de Fabricação"}
            name={"dataFabricacao"}
            format="dd/MM/yyyy"
            onChange={(date) => handleDateChange("dataFabricacao", date)}
            error={inputErros.get("dataFabricacao")}
            value={produto?.dataFabricacao}
          />
        </Grid>
        <Grid item xs={3}>
          <CurrencyInput
            required
            id="precoMaxConsumo"
            name="precoMaxConsumo"
            label="Preço Máximo de Consumo"
            margin="none"
            value={produto?.precoMaxConsumo}
            onBlur={handleFloatChange}
            onKeyDown={(e) => nextFocusInput(e)}
            error={inputErros.get("precoMaxConsumo")}
          />
        </Grid>
        <Grid item xs={3}>
          <TextField
            required
            id="numLote"
            name="numLote"
            label="Número de Lote"
            variant="outlined"
            InputLabelProps={{ shrink: true }}
            value={produto?.numLote}
            onChange={handleInputChange}
            InputProps={{ inputProps: { min: 0 } }}
            error={inputErros.get("numLote")}
            fullWidth
          />
        </Grid>
        <Grid item xs={3}>
          <TextField
            required
            id="qtdLote"
            name="qtdLote"
            label="Quantidade do Lote"
            variant="outlined"
            type="number"
            disableNumberArrows
            InputLabelProps={{ shrink: true }}
            value={produto?.qtdLote}
            onChange={handleInputChange}
            InputProps={{ inputProps: { min: 0 } }}
            error={inputErros.get("qtdLote")}
            fullWidth
          />
        </Grid>
        <Grid item xs={3}>
          <TextField
            required
            id="agregado"
            name="agregado"
            label="Agregado"
            variant="outlined"
            type="number"
            disableNumberArrows
            InputLabelProps={{ shrink: true }}
            value={produto?.agregado}
            onChange={handleInputChange}
            InputProps={{ inputProps: { min: 0 } }}
            error={inputErros.get("agregado")}
            fullWidth
          />
        </Grid>
        <Grid item xs={3}>
          <TextField
            required
            id="prodAnvisa"
            name="prodAnvisa"
            label="Prod. ANVISA"
            variant="outlined"
            InputLabelProps={{ shrink: true }}
            value={produto?.prodAnvisa}
            onChange={handleInputChange}
            error={inputErros.get("prodAnvisa")}
            fullWidth
          />
        </Grid>
        <Grid item xs={9}>
          <TextField
            required
            id="motivoIsencao"
            name="motivoIsencao"
            label="Motivo de Isenção"
            variant="outlined"
            InputLabelProps={{ shrink: true }}
            value={produto?.motivoIsencao}
            onChange={handleInputChange}
            error={inputErros.get("motivoIsencao")}
            fullWidth
          />
        </Grid>
      </Grid>
    </>
  );
};

export default FormAnvisaDialog;
